export const CREATE_NOTIFICATION = 'CREATE_NOTIFICATION'


// WEBPACK FOOTER //
// ./src/notification/NotificationConstants.js